export default __webpack_public_path__ + "static/media/leftArrow.25674e9d.svg";